import { Sun, Moon } from "@phosphor-icons/react";
import { useTheme } from "../context/ThemeContext";

export function ThemeToggle() {
  const { theme, toggleTheme } = useTheme();

  return (
    <button
      onClick={toggleTheme}
      aria-label={`Switch to ${theme === "dark" ? "light" : "dark"} mode`}
      className="fixed bottom-4 right-4 z-[60] flex h-10 w-10 items-center justify-center rounded-xl bg-white/80 dark:bg-slate-800/80 backdrop-blur-lg border border-slate-200 dark:border-slate-700 shadow-lg shadow-black/5 dark:shadow-black/20 text-slate-600 dark:text-slate-300 transition-all duration-200 hover:scale-110 hover:shadow-xl"
    >
      {theme === "dark" ? (
        <Sun size={18} weight="bold" />
      ) : (
        <Moon size={18} weight="bold" />
      )}
    </button>
  );
}
